import { createConfirmation } from 'react-confirm';

import ConfirmDialog from 'sharedreact/components/ConfirmDialog';

const _askConfirmation = createConfirmation(ConfirmDialog);

const askConfirmation = function (
  id: string,
  title: string,
  message: string,
  info?: string,
  setDontAskAgain?: (dontAskAgain: boolean) => void,
  yesButtonText?: string,
  noButtonText?: string
) {
  const props = {
    id: id,
    title: title,
    message: message,
    info: info,
    yesButtonText: yesButtonText,
    noButtonText: noButtonText,
    setDontAskAgain: setDontAskAgain
  };

  return _askConfirmation(props);
}

export default askConfirmation;
